import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_20: FaireProductEntity = {
  token: "catalog_prod_prod-20",
  type: "product",
  name: "Party Napkins - Confetti Pattern (Set of 20) - Style 2",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1602874801007-bd458bb1b8b6?w=400&h=400&fit=crop",
  priceDollars: 56.63,
  msrpDollars: 141.58,
  sku: "CO0020",
  caseSize: 4,
  material: "Wood",
  collectionToken: "col_confetti-cake",
  isNew: true,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 91,
  description: "Beautiful Confetti & Cake piece perfect for any home.",
  categoryTokens: ["catalog_cat_stickers-pins"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
